// extracted by mini-css-extract-plugin
var _1 = "OrganizationSummary-module__container--t1hCa";
export { _1 as "container" }
